<template>
  <div id="pageContent">
    <div id="formArea" class="borderBox">
      <div v-if="readyToWork">
        <div class="fl frstShortSeconLong" id="headOutgoing">
          <div>
            <div class="input_box">
              <label class="left">Тип продукта</label>
              <select v-model="productId">
                <option :value="option.ProductType" v-for="option in getProduct">{{option.DlProductTypeName}}</option>
              </select>
            </div>
            <div class="input_box">
              <label class="left">Сумма займа</label>
              <select v-model="requestSum">
                <option :value="Amount" v-for="Amount in getAvailableSum">{{Amount}}</option>
              </select>
            </div>
            <div class="input_box" v-show="getAvailablePeriod.length > 1">
              <label  class="left">Срок займа {{getSelectedPskInfo.calcWeekTitle}}</label>
              <select v-model="CALC_WEEK">
                <option :value="Period" v-for="Period in getAvailablePeriod">{{Period}}</option>
              </select>
            </div>
          </div>
          <div>
            <div class="fl" id="getPhoneBox">
              <formInput :refs="'PHONE_FOR_CALL'" :form="'LeadInfo'"></formInput>
              <div class="fl">
                <div class="button" v-on:click="getClientPhone">Получить номер телефона</div>
                <div class="button" v-on:click="redirectToCS">Перевести на Клиентский сервис</div>
              </div>
            </div>
            <formSelect :refs="'WHERE_TO_FIND_US'" :form="'request'"></formSelect>
          </div>
        </div>
        <productInfo></productInfo>
        <statusBar v-on:loadNewLead="loadNewLead"></statusBar>
        <formRequest v-on:loadNewLead="loadNewLead"></formRequest>

      </div>
      <div class="loaderWrap" v-else>
        <loader></loader>
      </div>
    </div>
    <div class="borderBox" id="operatorScript">
      <OperatorScriptLayout :parentID="'0'" :sourceId="'2'"></OperatorScriptLayout>
    </div>
  </div>
</template>

<script>

  import {mapGetters, mapState} from 'vuex'

  import DataForInput from '@/gavnoCode/longFormOptions';

  export default {
    name: "incoming",
    components: {
      OperatorScriptLayout: () => import('@/components/OperatorScript/OperatorScriptLayout'),
      productInfo: () => import('@/components/productInfo'),
      loader: () => import('@/components/loader'),
      statusBar: () => import('@/components/status/statusBarIn'),
      formRequest: () => import('@/components/forms/formRequest'),
      formInput: () => import('@/components/forms/formInput'),
      formSelect: () => import('@/components/forms/formSelect')
    },
    data: function () {
      return {
        readyToWork: false
      }
    },
    methods: {

      onSubmit: function () {
        //блокирем отправку формы по православному submit
      },
      redirectToCS: function () {
        this.$myApi.RedirectOperatorToCS().then((result) => console.log(result)).catch(e => console.log(e));
      },
      loadOperatorScript: function () {
        if (this.getIncomeScripts.length == 0) {
          this.$myApi.scriptContent()
          .then((result) => {
            this.$store.dispatch('setScripts', result)
          })
          .catch((msg) => {
            console.log(msg)
          });
        }
      },
      updateLibWTF: function () {
        return new Promise((resolve, reject) => {
          this.$myApi.getWTFlib()
          .then((result) => {
            let sortTemp = result.map(function (el, i) {
              return { index: i, value: el.nameOption.toLowerCase() };
            });

            sortTemp.sort(function(a, b) {
              if (a.value > b.value) {return 1;}
              if (a.value < b.value) {return -1;}
              return 0;
            });
            let sortArr = sortTemp.map(function(el){
              return result[el.index];
            });
            DataForInput.WHERE_TO_FIND_US.selectOption = sortArr;
            resolve();
          }).catch(e => {
            alert('Ошибка :' + e);
            reject();
          });
        });
      },
      checkVersion(){
        //проверяем нет ли свежего обновления на сайте, если есть обновляем страницу для загрузки нового гавнокодика
        return new Promise((resolve,reject) => {
          this.$myApi.singleRequest({
            action: 'Operator_checkVersion'
          }).then((res)=>{
            if (localStorage.getItem('cache') === null) {
              localStorage.setItem('cache', res.cache)
            } else if (localStorage.getItem(('cache')) != res.cache) {
              localStorage.setItem('cache', res.cache)
              document.location.reload();
            }
            resolve(res);
          })
            .catch((res)=>{
              this.$store.commit('setContent', 'Ошибка<hr>' + JSON.stringify(res));
              this.$store.commit('showModal');
              reject(res);
            });
        });
      },
      clearCurrentVuex(){
        this.readyToWork = false;
        this.$store.dispatch('resetToDefault');

        this.$store.dispatch('saveSendData', {
          target: 'REFFER',
          form: 'request',
          value: 'Входящая линия'
        });
        this.$store.dispatch('saveSendData', {
          target: 'requestType',
          form: 'status',
          value: 'Incoming'
        });
      },
      getDealType(){
        return new Promise((resolve, reject) => {
          // this.$myApi.SendRequest({action: 'Operator_Get_Ref_DealType'}, this, 'mountedPsk', false)
          //   .then((result) => {
          //     if (result.length > 0) {
          //       //если есть массив, значит пришли новые продукты, добавляем в фронт и сохроняем к нам в бд
          //       this.$store.dispatch('addPskTable', result);
          //       this.$myApi.saveDefaultDealType(result)
          //         .then(()=>{
          //           resolve();
          //         })
          //         .catch(e => {console.log(e);reject()});
          //     } else {
                this.$myApi.getDefaultDealType()
                .then((result) => {
                  this.$store.dispatch('addPskTable', result);
                  resolve();
                })
                .catch(e =>  {console.log(e);reject()})
            //   }
            // })
            .catch(e => {
              console.log(e);
              alert('Ошибка :' + e);
            });
        });
      },
      loadNewLead: function () {
        this.readyToWork = false;
        this.checkVersion().then(()=>{
          this.clearCurrentVuex();
          this.updateLibWTF().then(()=>{
            this.getDealType().then(()=>{
              this.readyToWork = true;
            }).catch(()=>{
              console.log('get deal fail');
            });
          }).catch(()=>{
            console.log('wtf fail');
          });
        }).catch((res)=>{
          console.log('income new lead fail');
        });
      },
      getClientPhone:function(){
          this.$myApi.SendRequest({action:'asterisk_getClientPhoneNumber'}, this, 'getClientPhone', false)
          .then((response)=>{
            if(response.PhoneNumber.toLowerCase() != 'обработан') {
             let phoneClient = response.PhoneNumber.substr(response.PhoneNumber.length - 10);
              this.$store.dispatch('saveSendData', {
                target: 'PHONE_FOR_CALL',
                form: 'LeadInfo',
                value: phoneClient
              });
            }
          })
          .catch((error)=>{});
      }
    },
    computed: {
      ...mapGetters(['getProfile', 'getProduct', 'getAvailableSum', 'getIncomeScripts','getAvailablePeriod','getSelectedPskInfo']),
      ...mapState({
        valueVuex: state => state.requestField['sendData'],
      }),
      productId: {
        get() {
          return this.valueVuex['request']['PRODUCT_ID']
        },
        set(value) {
          this.$store.dispatch('saveSendData', {
            target: 'PRODUCT_ID',
            form: 'request',
            value: value
          });
        }
      },
      requestSum: {
        get() {
          return this.valueVuex['request']['CALC_SUMM']
        },
        set(value) {
          this.$store.dispatch('saveSendData', {
            target: 'CALC_SUMM',
            form: 'request',
            value: value
          });
        }
      },
      CALC_WEEK: {
        get(){
          return this.valueVuex['request']['CALC_WEEK']
        },
        set(value){
          this.$store.dispatch('saveSendData',{
            target:'CALC_WEEK',
            form:'request',
            value: value
          });
        }
      }
    },
    watch: {

    },
    mounted() {
      this.loadNewLead();
      this.$store.dispatch('loadScriptById','2')
    }

  }
</script>

<style scoped>
  #formArea {
    width: 900px;
  }



  .loaderWrap {
    min-height: 66vh;
    height: 1px;
  }

  #operatorScript {
    margin: 0;
    width: calc(100% - 1070px);
    text-align: left;
    position: fixed;
    top: 10px;
    right: 10px;
    height: calc(100vh - 40px);
    overflow-x: scroll;
    margin: 0;
  }

  #getPhoneBox {
    align-items: center;
    justify-content: flex-start;
  }

  #getPhoneBox > div:first-child {
    width: 290px;
  }

  #getPhoneBox > div:last-child {
    margin: 6px 0 0 10px;
  }

  @media screen and (max-width: 1600px) {
    #pageContent{
      display: flex;
      flex-direction: column-reverse;
      justify-content: flex-end;
    }
    #operatorScript{
      margin: 10px 0 10px 90px;
      width: 900px;
      position: relative;
      top:0;
      right:0;
      height: auto;
      overflow: inherit;
    }
  }
</style>
